module.exports = "/build/images/BlueButton.svg?b5f974e7e53b952bdfdd3990a3ce3bb7";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/BlueButton.svg
// module id = 2426
// module chunks = 0